import { Keyboard } from '@capacitor/keyboard';
import { WlWindow } from 'typings/globals/cordova';
import getScrollParent from 'utils/getScrollParent';
import { isCordova } from 'utils/platform';

declare const window: WlWindow;

export function scrollToFocusedOnKeyboard() {
  if (!isCordova()) {
    return () => {};
  }
  const PADDING = 30;
  Keyboard.addListener('keyboardDidShow', (info) => {
    const element = document.activeElement as HTMLElement | null;
    if (!element) {
      return;
    }
    const offsetAttr = element.getAttribute?.('data-scrolloffset');
    const offset = parseInt(offsetAttr ?? '0', 10) || 0;

    const elementRect = element.getBoundingClientRect();
    if (elementRect.bottom >= window.innerHeight - offset) {
      const parent = getScrollParent(element);
      if (parent && typeof (parent as any).scrollBy === 'function') {
        (parent as any).scrollBy({
          behavior: 'smooth',
          top: elementRect.bottom - window.innerHeight + offset + PADDING,
        });
      } else if (parent && 'scrollTop' in (parent as any)) {
        (parent as any).scrollTop +=
          elementRect.bottom - window.innerHeight + offset + PADDING;
      }
    }
  });

  return () => {
    Keyboard.removeAllListeners();
  };
}
